import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ContentLoader from 'react-content-loader';
import { Icon } from 'components/shared';

import { HomePageButtonGeneral } from 'components/temoraryHomePage/index.js';

import { getApplicationsCollectionLength } from 'selectors';

import { WithUser } from 'hocs';
import { FOOTER_LINKS, HEADER_LINKS, MY_APPLICATIONS_PATH, SIGN_IN_PATH } from 'constants/routes';
import { userDefaultProps, userPropTypes } from 'propTypes';
import { getPath } from 'utils';

import { NavigationItem, NavigationLink, NavigationDropdown } from './shared';

const propTypes = {
  ...userPropTypes,
  applicationsCollectionLength: PropTypes.number.isRequired,
  userIsLoading: PropTypes.bool,
  footer: PropTypes.bool,
  location: PropTypes.objectOf(PropTypes.any),
};

const defaultProps = {
  ...userDefaultProps,
  footer: false,
  userIsLoading: false,
  allApplications: { collection: [] },
};

function Navigation({ footer, user, userIsLoading, location }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const links = footer ? FOOTER_LINKS : HEADER_LINKS;

  if (userIsLoading) {
    return (
      <ContentLoader height={10} speed={3} width={150} style={{ width: '150px' }}>
        <rect x="0" y="0" rx="5" ry="5" width="150" height="10" />
      </ContentLoader>
    );
  }

  const linksComponents = links.map(({ text, ...link }) => (
    <NavigationItem key={`nav-item-${link.url}`}>
      <NavigationLink {...link} key={`nav-link-${link.url}`}>
        {text}
      </NavigationLink>
    </NavigationItem>
  ));

  if (footer) {
    return <NavigationContainer>{linksComponents}</NavigationContainer>;
  }

  return (
    <NavigationWrapper>
      <MenuBurger onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {isMenuOpen ? <Icon icon="close" width='1.5' /> : <Icon icon="menuBurger" width='1.5' />}</MenuBurger>
      <NavigationContainer isMenuOpen={isMenuOpen}>
        {!user && !userIsLoading && (
          <>
            <StyledPhoneLink href="tel:8889871276">
              <p>Talk To A Loan Advisor: <StyledNumber>(888) 987-1276</StyledNumber></p>
            </StyledPhoneLink>
            {linksComponents}
          </>
        )}
        {user && (
          <NavigationItem>
            <NavigationLink url={getPath(MY_APPLICATIONS_PATH, { id: user.id, status: 'active' })}>
              My Applications
            </NavigationLink>
          </NavigationItem>
        )}
        <NavigationItem>
          {user ? (
            <NavigationDropdown />
          ) : (
            <NavigationLink url={{ pathname: SIGN_IN_PATH, state: { from: location } }}>
              <HomePageButtonGeneral type="tertiary" size="small">Sign in</HomePageButtonGeneral>
            </NavigationLink>
          )}
        </NavigationItem>
      </NavigationContainer>
    </NavigationWrapper>
  );
}

const NavigationWrapper = styled.div`
 
`;

const MenuBurger = styled.div`
  display: none;
  cursor: pointer;
  color: #fff;
  @media (max-width: 1200px) {
    display: flex;
  }
`;

const StyledNumber = styled.span`
  font-weight: 700;
`

const NavigationContainer = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1200px) {
    display: ${({ isMenuOpen }) => (isMenuOpen ? 'flex' : 'none')};
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    position: absolute;
    top: 58px;
    left: 0;
    color: var(--color-primary);
    width: 100vw;
    background-color: #fff;
    z-index: 10;
    button {
      width: 100%;
      margin: 0;
      padding: 20px 0;
      text-align: center;
      flex: 1 0 au
    }
    
  }
`;

const StyledPhoneLink = styled.a`
  text-decoration: none;
  font-size: var(--font-size-xs);
  line-height: 14px;
  color: #fff;
  cursor: pointer;
  -webkit-transition: color cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
  transition: color cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
  padding-right: 30px;

  &:hover {
    color: var(--color-secondary-hover);
  }

  &.active {
    color: var(--color-secondary-hover);
  }
  @media (max-width: 1200px) {
    text-align: left;
    color: #1E1E1E;
    font-size: var(--font-size-xs);
    line-height: 19px;
    font-weight: 700;
    width: 100%;
    padding: 18px 71px 18px 24px;
    border-bottom: 1px solid #E7DAC5;
    margin-bottom: 0;
    &:hover {
    color:  var(--color-secondary);
    }

    &.active {
    color:  var(--color-secondary);
    }
  }
`;

Navigation.propTypes = propTypes;
Navigation.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    applicationsCollectionLength: getApplicationsCollectionLength(state),
  };
}

const enhance = compose(
  withRouter,
  WithUser,
  connect(mapStateToProps),
  pure,
);

export default enhance(Navigation);
